import {
  GetObjectCommand,
  PutObjectCommand,
  PutObjectCommandInput,
  S3Client,
} from "@aws-sdk/client-s3";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";

const client = new S3Client({
  region: "auto",
  endpoint: "https://f964df396b350244a8443b80a0298ce6.r2.cloudflarestorage.com",
  credentials: {
    accessKeyId: process.env.AWS_ACCESS_KEY_ID || "",
    secretAccessKey: process.env.AWS_SECRET_ACCESS_KEY || "",
  },
});

const bucketName = process.env.AWS_S3_BUCKET;
const bucketNameUserContent = process.env.AWS_S3_BUCKET_USER_CONTENT;

export async function s3PutPublic(
  Key: string,
  Body: PutObjectCommandInput["Body"],
) {
  const path = `app/${Key}`;
  const command = new PutObjectCommand({
    Bucket: bucketName,
    Key: path,
    Body,
    ACL: "public-read",
  });

  try {
    const response = await client.send(command);
    return path;
  } catch (err) {
    console.error(err);
  }
}

export async function s3PutUserContent(
  Key: string,
  Body: PutObjectCommandInput["Body"],
) {
  const command = new PutObjectCommand({
    Bucket: bucketNameUserContent,
    Key,
    Body,
  });

  try {
    await client.send(command);
    return Key;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function generatePresignedUrl(objectKey: string) {
  const command = new GetObjectCommand({
    Bucket: bucketNameUserContent,
    Key: objectKey,
  });

  try {
    const signedUrl = await getSignedUrl(client as any, command, {
      expiresIn: 60 * 5,
    });

    try {
      const URLObj = new URL(signedUrl);

      return URLObj.href.replace(
        URLObj.origin,
        "https://user-content.talencat.com",
      );
    } catch (error) {
      return signedUrl;
    }
  } catch (error) {
    console.error("Error generating presigned URL:", error);
    throw error;
  }
}

export const awsS3BaseUrl = "https://cdn.talencat.com/";
